import { atom } from 'jotai'
import { User } from './user';
const l_userAtom = atom(JSON.parse(localStorage.getItem('target#_user')) as User ?? {
    id: '',
    loggedIn: false,
    role:''
} as User);

export const userAtom = atom(
  (get) => get(l_userAtom),
  (get, set, newUser) => {
    set(l_userAtom, newUser)
    localStorage.setItem('target#_user', JSON.stringify(newUser))
  },
)